const state = {
    user: null
}

const getters = {
    user: state => {
        return state.user;
    }
}

const mutations = {
    updateUser: (state, payload) => {
        state.user = payload;
    }
}

const actions = {
    updateUser: ({ commit }, payload) => {
        commit('updateUser', payload);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}